import firebase from 'firebase';

export default{

    mutations: {
        setGroups(state, payload) {
            this.state.groups = payload;
            this.state.updatecount++;
        },
        addGroup(state, payload) {
            //alert('addGroup');
            if (payload.Contacts == null)
                payload.Contacts = [];
            this.state.groups.push(payload);
            this.state.updatecount++;
        },
        cutGroup(state,payload){
            const deleted = this.state.groups.find(group => group.ID === payload);
            const index = this.state.groups.indexOf(deleted);
            this.state.groups.splice(index, 1);
            this.state.updatecount++;
        },
        changedGroup(state,payload){
            //alert('changedGroup ' + payload.Name);
            var changed = this.state.groups.find(group => group.ID === payload.ID);
            changed.Name = payload.Name;
            changed.ContactCount = payload.ContactCount;
            changed.Contacts = payload.Contacts;
            this.state.updatecount++;
        }
    },
    actions:{
        setGroup(state, group) {
            var dat = { ...group};
            delete (dat.ID);
            delete (dat.ContactCount);
            delete (dat.IsSelected);
            delete (dat.val);
            if ((dat.Contacts != null) && (dat.Contacts.length == 0))
                delete (dat.Contacts);
            firebase.database().ref('databases/' + state.rootState.databaseid + '/users/' + state.rootState.user.uid + '/mydata/mygroups/' + group.ID ).set(dat);
        },
        addGroup(state, group) {
            firebase.database().ref('databases/' + state.rootState.databaseid + '/users/' + state.rootState.user.uid + '/mydata/mygroups').push(group);
        },
        cutGroup(state, group) {
            firebase.database().ref('databases/' + state.rootState.databaseid + '/users/' + state.rootState.user.uid + '/mydata/mygroups/'+group.ID).remove();
        }
    }
}